module.exports = __webpack_public_path__ + "img/thumbnail_Cassowary_f_normal.c87fdc41.png";